import { Component } from '@angular/core';
import { NbButtonModule } from '@nebular/theme';
import { TranslateService, TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'ngd-eva',
    styleUrls: ['./eva.components.scss'],
    templateUrl: './eva.component.html',
    standalone: true,
    imports: [NbButtonModule, TranslateModule],
})
export class NgdEvaComponent {
    constructor(public translate: TranslateService) {}
}
